// Custom script - Menu hover behavior
document.addEventListener('DOMContentLoaded', function() {
  const navMenuItems = document.querySelectorAll(".header-menu-hasdropdown");
  
  navMenuItems.forEach((menuItem, index) => {
    const detailsElement = menuItem.querySelector('details');
    
    if (detailsElement) {
      // Open submenu on hover
      menuItem.addEventListener("mouseenter", () => {
        detailsElement.setAttribute('open', '');
        const summary = detailsElement.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Close submenu when mouse leaves
      menuItem.addEventListener("mouseleave", () => {
        detailsElement.removeAttribute('open');
        const summary = detailsElement.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
});